import {
    ContactState,
    ContactActionTypes,
    SHOW_CONTACT_FORM,
    HIDE_CONTACT_FORM,
    SEND_MESSAGE,
    SHOW_CONTACT_CONFIRM,
    HIDE_CONTACT_CONFIRM
} from "./types";

const initialState: ContactState = {
    contactForm: {
        isShowing: false,
        emailText: "",
        messageText: ""
    },
    contactConfirm: {
        isShowing: false
    }
};

export default (state: ContactState = initialState, action: ContactActionTypes): ContactState => {
    switch (action.type) {
        case SHOW_CONTACT_FORM:
            return {
                ...state,
                contactForm: {
                    ...state.contactForm,
                    isShowing: true
                }
            };
        case HIDE_CONTACT_FORM:
            return {
                ...state,
                contactForm: {
                    ...state.contactForm,
                    isShowing: false
                }
            };
        case SEND_MESSAGE:
            return {
                ...state,
                contactForm: {
                    ...state.contactForm,
                    emailText: action.payload.emailText,
                    messageText: action.payload.messageText
                }
            };
        case SHOW_CONTACT_CONFIRM:
            return {
                ...state,
                contactConfirm: {
                    isShowing: true
                }
            };
        case HIDE_CONTACT_CONFIRM:
            return {
                ...state,
                contactConfirm: {
                    isShowing: false
                }
            };
        default:
            return state;
    }
};
